
import React from "react";
import { Link } from '@albo-ui/core'

export const CircleDays = ({ days_update }) => {
    if (days_update < 2)
        return <div className="circle-success" />

    if (days_update < 7)
        return <div className="circle-warning" />

    return <div className="circle-error" />
}

export const ResponsibleCell = ({ row }) => {
    return <Link underlined style={{
        display: "flex", flexWrap: "nowrap",
        alignItems: "center"
    }}>
        <CircleDays days_update={row.days_update} /> {row.responsible}
    </Link>
}
